var render = function render(){var _vm=this,_c=_vm._self._c;return _c('List',{attrs:{"items":_vm.items,"totalMedicamentosPendentes":_vm.totalMedicamentosPendentes},on:{"dispensar":function($event){return _vm.$emit('dispensar', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }